import { doc, getDoc, updateDoc, arrayUnion, serverTimestamp } from 'firebase/firestore';
// ⚠️ Update this import to match wherever your app initializes Firestore.
import { db } from '../firebase';

const USERS_COLLECTION = 'users';

// Reads the fields the mascot needs off the user's existing doc.
// Nothing here creates a new doc — it assumes `users/{uid}` already exists.
export async function getMascotUserData(uid) {
  const ref = doc(db, USERS_COLLECTION, uid);
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    return { authorName: '', seenMessageIds: [], mascotLastShown: null };
  }

  const data = snap.data();
  return {
    authorName: data.authorName || '',
    seenMessageIds: data.seenMessageIds || [],
    mascotLastShown: data.mascotLastShown ? data.mascotLastShown.toMillis() : null,
  };
}

// Called when a message is dismissed — records it as seen and stamps the
// time, so the random auto-trigger can respect its cooldown.
export async function markMessageSeen(uid, messageId) {
  const ref = doc(db, USERS_COLLECTION, uid);
  await updateDoc(ref, {
    seenMessageIds: arrayUnion(messageId),
    mascotLastShown: serverTimestamp(),
  });
}